'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import PortalIdParser from 'PortalIdParser';
import { parse } from 'hub-http/helpers/params';
import getCookie from '../utils/getCookie';
import { api } from '../utils/urls';

var addApiCsrf = function addApiCsrf(request) {
  request.setRequestHeader('X-HubSpot-CSRF-hubspotapi', getCookie('csrf.app'));
};

var setBaseRequestProps = function setBaseRequestProps(request) {
  request.withCredentials = true;
  request.setRequestHeader('Accept', 'application/json');
  request.setRequestHeader('Content-type', 'application/json');
  addApiCsrf(request);
};

var tryParseAsJSON = function tryParseAsJSON(resp) {
  try {
    return JSON.parse(resp);
  } catch (e) {
    return resp;
  }
};

var GET = function GET(path, cb, cbFail) {
  var request = new XMLHttpRequest();
  request.open('GET', path);
  setBaseRequestProps(request);

  request.onload = function () {
    if (this.status >= 200 && this.status < 400) {
      if (cb) {
        cb(tryParseAsJSON(this.response));
      }
    } else {
      cbFail(this);
    }
  };

  request.onerror = function () {
    cbFail();
  };

  request.send();
};

var HomeDAO = /*#__PURE__*/function () {
  function HomeDAO() {
    _classCallCheck(this, HomeDAO);
  }

  _createClass(HomeDAO, null, [{
    key: "get",
    value: function get() {
      var portalIdFromEndpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var cb = arguments.length > 1 ? arguments[1] : undefined;
      var cbf = arguments.length > 2 ? arguments[2] : undefined;
      var portalId = portalIdFromEndpoint || PortalIdParser.getPortalIdFromQueryParam() || getCookie('hubspot.hub.id');
      var apiPath = portalId ? '/home/v2/api' : '/home/v2/api/no-intended-portal';
      var params = portalId ? {
        portalId: portalId
      } : {};

      if (window.location && window.location.search) {
        var searchParams = parse(window.location.search.replace(/^\?/, ''));
        Object.keys(searchParams).forEach(function (key) {
          params[key] = searchParams[key];
        });
      }

      return GET("" + api(apiPath) + (portalId ? "?portalId=" + portalId : ''), cb, cbf);
    }
  }, {
    key: "getUserPortalId",
    value: function getUserPortalId(cb, cbf) {
      var apiPath = '/home/v2/api/portal';
      return GET(api(apiPath), cb, cbf);
    }
  }]);

  return HomeDAO;
}();

export { HomeDAO as default };